export const getBuyerAgreementAttachmentOffsets = {
  pageNumber: 10,
  offsetLeft: 96,
  offsetTop: 138,
};
